<div class="leg-container">
  <div
    class="leg"
    [ngClass]="{
      'leg--dim': !leg.checked,
      'leg--rfq': rfqExecutionSettings.rfqLeg,
      'leg--direct-rfq': rfqExecutionSettings.directRfq
    }"
  >
    <div
      class="leg__header"
      *ngIf="!rfqExecutionSettings.static && !rfqExecutionSettings.directRfq"
    >
      <div class="clr-checkbox-wrapper">
        <input
          *ngIf="!rfqExecutionSettings.rfqLeg"
          type="checkbox"
          [id]="'checkbox-leg' + (legIndex + 1)"
          name="checkbox-basic"
          value="option1"
          [ngModel]="leg.checked"
          (click)="checkboxClicked($any($event.target).checked)"
          class="checkbox clr-checkbox"
        />
        <label
          class="checkbox__label clr-control-label"
          [for]="
            !rfqExecutionSettings.rfqLeg ? 'checkbox-leg' + (legIndex + 1) : ''
          "
          [ngClass]="{
            'checkbox__label--no-padding':
              rfqExecutionSettings.rfqLeg && !rfqExecutionSettings.static
          }"
        >
          Leg {{ legIndex + 1 }}
        </label>
      </div>

      <div class="leg__dragarea">
        <ng-content></ng-content>
      </div>

      <div class="leg__buttons-container">
        <button
          class="header-button"
          (click)="descriptionClick()"
          *ngIf="leg.legDescription.description?.length > 0"
        >
          <img src="assets/info.svg" />
        </button>
        <button
          class="header-button"
          (click)="onSaveTradeClick()"
          [disabled]="!form.valid"
          *ngIf="tradingMode"
        >
          <img
            [src]="
              form.valid ? 'assets/save-2.svg' : 'assets/save-2-disabled.svg'
            "
          />
        </button>
        <div *ngIf="leg.productType === 'newdcd'">
          <button
            class="header-button"
            *ngIf="
              leg.pricedLeg?.childVanillaOption && !rfqExecutionSettings.rfqLeg
            "
            (click)="onDCDVanillaEmitted()"
            style="color: #fff"
          >
            C
          </button>
        </div>
        <button
          class="header-button"
          [disabled]="rfqExecutionSettings.isPricing"
          (click)="onDuplicateClick()"
        >
          <img src="assets/duplicate.svg" />
        </button>
        <button
          *ngIf="!rfqExecutionSettings.rfqLeg"
          class="header-button"
          (click)="onSolverClick()"
          [disabled]="!form.valid"
        >
          <img
            [src]="form.valid ? 'assets/calc.svg' : 'assets/calc-disabled.svg'"
          />
        </button>
        <button
          [disabled]="rfqExecutionSettings.isPricing"
          class="header-button"
          (click)="onRemoveLeg()"
        >
          <img src="assets/delete.svg" />
        </button>
      </div>
    </div>
    <form
      [formGroup]="form"
      autocomplete="off"
      [inert]="formInert || !leg.checked"
    >
      <ng-container
        *ngFor="
          let activeAttribute of legService.activeAttributes()
            | activeAttributes: leg.attributesAsFormControls
        "
      >
        <div
          class="form-row"
          [ngClass]="{
            'form-row--hide-attribute-container':
              activeAttribute?.hideAttributeContainer
          }"
        >
          <ng-container
            *ngIf="
              activeAttribute && activeAttribute.controlType === 'list';
              else singleAttribute
            "
          >
            <div
              class="form-row__leg-attributes form-row__leg-attributes--background"
            >
              <ng-container
                *ngFor="
                  let singleAttributeOfAttributes of activeAttribute.attributes;
                  let i = index
                "
              >
                <leg-attribute
                  *ngIf="
                    singleAttributeOfAttributes?.display &&
                    !singleAttributeOfAttributes.hide
                  "
                  [attribute]="singleAttributeOfAttributes"
                  [form]="form"
                ></leg-attribute>
              </ng-container>
              <div class="form-row__leg-attributes__empty-block"></div>
            </div>
          </ng-container>

          <ng-template #singleAttribute>
            @if (
              !rfqExecutionSettings.rfqLeg || !activeAttribute?.hideInRfqPanel
            ) {
              <div
                class="form-row__leg-attributes"
                [ngClass]="{
                  'form-row__leg-attributes--background':
                    activeAttribute && activeAttribute.display
                }"
              >
                <leg-attribute
                  *ngIf="activeAttribute?.display && !activeAttribute.hide"
                  [attribute]="activeAttribute"
                  class="key__{{ activeAttribute.key }} "
                  [form]="form"
                  (onDropdownChange)="onDropdownChange()"
                  (onButtonClick)="onButtonClick()"
                ></leg-attribute>
                @if (
                  activeAttribute?.allowSyncLegs &&
                  enableSpreadAttributeValue &&
                  leg.checked
                ) {
                  @if (this.legIndex === this.firstCheckedLegIndex) {
                    <cds-icon
                      shape="arrow"
                      direction="right"
                      class="form-row__leg-attributes__copy-icon"
                      (click)="
                        spreadAttributeValue(
                          activeAttribute.key,
                          activeAttribute.textColor
                        )
                      "
                    >
                    </cds-icon>
                  } @else if (this.legIndex === this.lastCheckedLegIndex) {
                    <cds-icon
                      shape="arrow"
                      direction="left"
                      class="form-row__leg-attributes__copy-icon"
                      (click)="
                        spreadAttributeValue(
                          activeAttribute.key,
                          activeAttribute.textColor
                        )
                      "
                    >
                    </cds-icon>
                  } @else if (
                    this.legIndex > this.firstCheckedLegIndex &&
                    this.legIndex < this.lastCheckedLegIndex
                  ) {
                    <cds-icon
                      shape="two-way-arrows"
                      class="form-row__leg-attributes__copy-icon"
                      (click)="
                        spreadAttributeValue(
                          activeAttribute.key,
                          activeAttribute.textColor
                        )
                      "
                    >
                    </cds-icon>
                  }
                }
                <div class="form-row__leg-attributes__empty-block"></div>
              </div>
            }
          </ng-template>
        </div>
      </ng-container>

      <div *ngIf="!rfqExecutionSettings.rfqLeg" class="form-row__button">
        <button
          class="ui-button primary"
          [disabled]="isLegDisabledTmpl"
          (click)="onPricingSubmit()"
          type="button"
        >
          <div
            class="form-row__button__spinner"
            *ngIf="leg.disablePricingButton; else allowPricing"
          >
            <span class="spinner spinner-sm spinner-inverse"> </span>
          </div>
          <ng-template #allowPricing> Price </ng-template>
        </button>
      </div>
      <ng-container *ngIf="!rfqExecutionSettings.rfqLeg">
        <pricing-results-display
          *ngIf="
            showResult('resultSpecifications') &&
            leg.pricedLeg &&
            !leg.loadingPrices &&
            !leg.pricingErrorMsg
          "
          [productType]="leg.productType"
          [pricedLeg]="leg.pricedLeg"
          [position]="leg.position"
          [baseCurrency]="leg.baseCurrency"
          [quoteCurrency]="leg.quoteCurrency"
          [showMid]="leg.isMidToggled"
          (showMidEmit)="onShowMidToggleEmit($event)"
        ></pricing-results-display>
        <market-data-display
          *ngIf="
            showResult('marketDataSpecifications') &&
            leg.pricedLeg &&
            !leg.loadingPrices &&
            !leg.pricingErrorMsg
          "
          [pricedLeg]="leg.pricedLeg"
          [cross]="leg.usableCross || leg.baseCurrency + leg.quoteCurrency"
          [attributesAsFormControls]="leg.attributesAsFormControls"
        ></market-data-display>
        <extra-results-display
          *ngIf="
            showResult('markUpSpecifications') &&
            leg.pricedLeg &&
            !leg.loadingPrices &&
            !leg.pricingErrorMsg &&
            leg.extraResultsAttributes?.length
          "
          [extraResults]="leg.extraResultsAttributes"
          [pricedLeg]="leg.pricedLeg"
          [depositCurrency]="leg.depositCurrency"
          [currencyPair]="leg.depositCurrency + leg.alternativeCurrency"
          [baseCurrency]="leg.baseCurrency"
        >
        </extra-results-display>

        <app-dcd-results-display
          *ngIf="
            showResult('dcdSpecifications') &&
            leg.pricedLeg &&
            !leg.loadingPrices &&
            !leg.pricingErrorMsg &&
            leg.dcdResultsAttributes?.length
          "
          [pricedLeg]="leg.pricedLeg"
          [depositCurrency]="leg.depositCurrency"
          [alternativeCurrency]="leg.alternativeCurrency"
          class="results results--top-margin"
        ></app-dcd-results-display>
        <div
          class="pricing-loading-container"
          *ngIf="leg.pricingErrorMsg && !leg.loadingPrices"
        >
          <div class="error-message-container">
            {{ leg.pricingErrorMsg }}
          </div>
        </div>
      </ng-container>
    </form>
  </div>
</div>

<ui-modal modalTitle="Description" #modal>
  <app-leg-description
    [legChecked]="leg.checked"
    [legDescription]="leg.legDescription"
    [parentModal]="modal"
  ></app-leg-description>
</ui-modal>

<app-copy-leg-modal
  *ngIf="copyLegOpen"
  [productType]="leg.productType"
  [isModalOpened]="copyLegOpen"
  (copyLeg)="onCopyLegEmitted($any($event))"
  (copyLegOpenChanged)="onCopyLegOpenChanged($event)"
>
</app-copy-leg-modal>

<app-solver
  *ngIf="solverOpen"
  [legComponent]="this"
  [isModalOpened]="solverOpen"
  (applySolver)="onApplySolver($event)"
  (solverOpenChanged)="onSolverOpenChanged($event)"
>
</app-solver>

<app-schedule
  *ngIf="
    leg.scheduleOpened &&
    form.value[leg.scheduleOpened]?.length &&
    (!rfqExecutionSettings.rfqLeg ||
      (rfqExecutionSettings.rfqLeg &&
        rfqService.executionContext.executionTypes.length &&
        rfqService.executionContext.executionTypes[0].shortName !==
          'genericMultiHedge'))
  "
  [columns]="leg.scheduleColumnNames"
  [additionalColumns]="leg.extraScheduleData[leg.scheduleOpened]?.columns || []"
  [flows]="leg.extraScheduleData[leg.scheduleOpened]?.data || []"
  [legData]="form"
  [scheduleName]="leg.scheduleOpened"
  [isModalOpened]="!!leg.scheduleOpened"
  [rfqLegSettings]="rfqExecutionSettings"
  [leg]="leg"
  (scheduleOpenChanged)="leg.scheduleOpened = null"
  (fieldChanges)="onScheduleFieldChange($event)"
>
</app-schedule>

<app-basket
  *ngIf="leg.showBasket"
  [legForm]="form"
  (basketOpenChanged)="setBasketModalState(false)"
></app-basket>

<app-options-portfolio
  *ngIf="leg.showOptionsPortfolio"
  [legForm]="form"
  (optionsPortfolioOpenChanged)="setOptionsPortfolioModalState($event)"
  (requestLatestSpot)="optionsPortfolioRequestSpot($event)"
></app-options-portfolio>

<app-options-portfolio-spots
  *ngIf="leg.showOptionsPortfolioSpots"
  [isOpened]="leg.showOptionsPortfolioSpots"
  [legForm]="form"
  (optionsPortfolioSpotsOpenChanged)="
    setOptionsPortfolioSpotsModalState($event)
  "
  (requestLatestSpot)="optionsPortfolioRequestSpot($any($event))"
></app-options-portfolio-spots>

<app-save-trade
  *ngIf="saveTradeOpen"
  [isModalOpened]="saveTradeOpen"
  [legForm]="this.form"
  [leg]="leg"
  (saveTradeOpenChanged)="onSaveTradeOpenChanged($event)"
></app-save-trade>

<app-warning-screen
  *ngIf="warningScreenData.warningScreenOpen"
  [isModalOpened]="warningScreenData.warningScreenOpen"
  [headerMessage]="warningScreenData.headerMessage"
  [messageToDisplay]="warningScreenData.messageToDisplay"
  (communicate)="warningScreenResponse($event)"
  (warningOpenChanged)="warningOpenChanged($event)"
></app-warning-screen>
